import * as React from 'react';

import { SearchTags } from '../../../../../../../common/components/search_tags';

interface IWordsExcludeProps {
  wordsExclude: string[];
  isModerator: boolean;
  onWordExcludeAdded(word: string): void;
  onWordExcludeRemoved(word: string): void;
}

export const WordsExclude: React.FC<IWordsExcludeProps> = props => (
  <SearchTags
    isModerator={props.isModerator}
    words={props.wordsExclude}
    onWordAdded={props.onWordExcludeAdded}
    onWordRemoved={props.onWordExcludeRemoved}
    tagStyle={{ backgroundColor: 'rgba(255, 80, 80, 0.2)', color: '#121212' }}
    placeholder="Например: переуступка"
  />
);
